export default __webpack_public_path__ + "static/media/goal-bn1.304b7846.png";